import {
  Bell,
  Binoculars,
  CreditCard,
  Gear,
  type Icon,
  Key,
  Palette,
  PlugsConnected,
  UserCircle,
} from '@phosphor-icons/react';

export type SettingsSection = {
  /** Path under /settings. */
  path: string;
  title: string;
  description: string;
  icon: Icon;
};

/** The Settings index rows, in Figma order ("Settings — Index", 325:3457). */
export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    path: 'general',
    title: 'General',
    description: 'Workspace name, logo, defaults and publishing rules.',
    icon: Gear,
  },
  {
    path: 'brand-profile',
    title: 'Brand profile',
    description: 'What you sell, who it’s for, tone and guardrails.',
    icon: Palette,
  },
  {
    path: 'competitors',
    title: 'Competitors',
    description: 'Whose TikTok and Instagram we watch for posts that take off.',
    icon: Binoculars,
  },
  {
    path: 'connected-accounts',
    title: 'Connected accounts',
    description:
      'TikTok, Instagram, YouTube and Facebook accounts for your brand and personas.',
    icon: PlugsConnected,
  },
  {
    path: 'billing',
    title: 'Billing & plan',
    description: 'Plan, usage, payment method and invoices.',
    icon: CreditCard,
  },
  {
    path: 'api',
    title: 'API & MCP',
    description: 'MCP server, connected agents, API keys and webhooks.',
    icon: Key,
  },
  {
    path: 'account',
    title: 'Account & security',
    description: 'Your profile, password, two-factor and active sessions.',
    icon: UserCircle,
  },
  {
    path: 'notifications',
    title: 'Notifications',
    description: 'What reaches you by email and in the app.',
    icon: Bell,
  },
];
